import { createContext, useReducer, useEffect } from "react";
import reducer from "../reducer/sidebarReducer";
import PropTypes from "prop-types";

// Check device type and set initial sidebar state
const getInitialSidebarState = () => {
  if (typeof window !== "undefined") {
    const width = window.innerWidth;
    if (width < 768) {
      // Mobile: default closed (false = closed)
      return false;
    } else if (width < 1024) {
      // Tablet: default closed (false = closed)
      return false;
    } else {
      // Desktop: default open (true = open)
      return true;
    }
  }
  return true; // Default to open for SSR (desktop behavior)
};

const initialState = {
  isSidebarOpen: getInitialSidebarState(),
};

export const SidebarContext = createContext({});
export const SidebarProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const toggleSidebar = () => {
    dispatch({ type: "TOGGLE_SIDEBAR" });
  };

  const setSidebarState = (isOpen) => {
    dispatch({ type: "SET_SIDEBAR", payload: isOpen });
  };

  // Handle window resize to automatically adjust sidebar state
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let shouldBeOpen;

      if (width < 768) {
        // Mobile: should be closed (false)
        shouldBeOpen = false;
      } else if (width < 1024) {
        // Tablet: should be closed (false)
        shouldBeOpen = false;
      } else {
        // Desktop: should be open (true)
        shouldBeOpen = true;
      }

      // Only update if the current state doesn't match what it should be
      if (state.isSidebarOpen !== shouldBeOpen) {
        setSidebarState(shouldBeOpen);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [state.isSidebarOpen]);

  return (
    <SidebarContext.Provider
      value={{
        ...state,
        toggleSidebar,
        setSidebarState,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.node,
};
